// extracted by mini-css-extract-plugin
var _1 = "PopupSeparator_separator__A5tXu";
export { _1 as "separator" }
